import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Material
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatMenuModule } from '@angular/material/menu';

// Store
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { reducers } from './store';
import { AiChatEffects } from './store/effects/ai-chat.effects';

import { AiChatDialogComponent } from './dialogs/ai-chat-dialog/ai-chat-dialog.component';
import { ChatMessageComponent } from './components/chat-message/chat-message.component';
import { HtmlTruncatePreservePipe } from './pipes/html-truncate-preserve.pipe';
import { ExpandableTextDirective } from './directives/expandable-text.directive';

@NgModule({
  declarations: [AiChatDialogComponent, ChatMessageComponent, HtmlTruncatePreservePipe, ExpandableTextDirective],
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature('aiChat', reducers),
    EffectsModule.forFeature([AiChatEffects]),
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatMenuModule,
  ],
  providers: [HtmlTruncatePreservePipe],
})
export class AiChatModule {}
